var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRefreshButtonGrey = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 60,
  height: 48,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 60,
  height: 48,
  fill: "#D3D3DF",
  rx: 24
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#66668F",
  d: "M37.06 16.938A9.96 9.96 0 0 0 29.995 14C24.465 14 20 18.475 20 24s4.465 10 9.994 10c4.665 0 8.555-3.187 9.668-7.5h-2.601a7.49 7.49 0 0 1-7.067 5c-4.14 0-7.505-3.363-7.505-7.5s3.365-7.5 7.505-7.5c2.076 0 3.927.863 5.278 2.225l-4.027 4.025H40V14z"
})));
export default SvgRefreshButtonGrey;